<template>
  <div class="outer">
    <div class="inner">
      <div class="topCard">
        <div class="list_item flex">
          <div class="list_item01 flex flex-between">
            <div class="imgbox">
              <img :src="cardDetail.imgUrl" alt />
            </div>
          </div>
          <div class="list_item02">
            <div class="cardName">
              <span>{{cardDetail.packageName}}</span>
            </div>
            <div class="price">
              <span>￥{{cardDetail.packageAmount}}</span>
            </div>
            <div class="date_txt">
              <span>有效期:{{cardDetail.endDate}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="phone_call">
        <div class="numTxt">
          <span>咨询热线：{{cardDetail.consultPhone}}</span>
        </div>
        <div class="phone_btnBox" @click="phoneCall">
          <div class="container_imgbox">
            <img src="../../assets/image/my/phone_call.png" alt />
          </div>
        </div>
      </div>

      <div class="bodyContent">
        <div class="title">
          <div class="txt">服务详情</div>
        </div>
        <div class="content flex flex-wrap">

          <div
            :class="['content_item',index%2==0?'content_item_left':'content_item_right']"
            v-for="(item,index) in serveList"
            :key="index"
          >

            <div class="imgbox">
              <img :src="item.imgUrl" alt />
            </div>
            <div class="txt">
              <span>{{item.serviceName}}</span>
            </div>

            <div class="num">
              <span v-if="item.serviceNum==0">无限次</span>
              <span
                v-else-if="item.serviceNum!=0"
              >总共{{item.serviceNum}}次 剩余{{item.serviceNum-item.consumeNum}}次</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { getApi } from "../../api/index.js";
export default {

  data() {
    return {
      cardDetail: {},
      serveList: [],
      // 类名
      content_item: "content_item"
    };
  },
  created: function() {
    this.getCardDetail();
  },
  methods: {
    // 拨打电话
    phoneCall: function(msg) {
      window.location.href = `tel:${this.cardDetail.consultPhone}`;
    },
    // 获取详情列表
    getCardDetail() {
      getApi({ url: "/card/detail/" + this.$route.query.cardUid, query: {} })
        .then(res => {
          if (res && res.resCode == "0") {
            // console.log(res);
            this.cardDetail = res.data;
            this.serveList = res.data.service;
            console.log(this.cardDetail);
            console.log(this.serveList);
          }
        })
        .catch(res => {
          // console.log(res);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.outer {
  height: 100%;
  width: 100%;
}
.inner {
  box-sizing: border-box;
  width: 100%;
}
.topCard {
  padding: 0 0.32rem;
  background-color: rgb(255, 255, 255);
  padding-top: 0.32rem;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 0.16rem;
}

.phone_call {
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  margin-bottom: 0.3rem;
  border-top: 0.01rem solid #dfdfe2;
  border-bottom: #dfdfe2 0.01rem solid;
  .numTxt {
    // float: left;
    padding: 0.25rem 0.3rem;
  }
  .phone_btnBox {
    padding: 0.25rem 0.3rem;
    // box-sizing: border-box;
    border-left: 0.01rem solid #dfdfe2;

    .container_imgbox {
      width: 0.8rem;
      img {
        margin: 0 auto;
        display: block;
        width: 0.5rem;
        height: 0.5rem;
      }
    }
  }
}

.list_item {
  box-sizing: border-box;
  width: 100%;
  border-radius: 0.2rem;
  background-color: rgb(255, 255, 255);
  // box-shadow: 0rem 0rem 0.2rem rgba(33, 22, 19, 0.2);
  .list_item01 {
    overflow: hidden;
    box-sizing: border-box;
    .imgbox {
      width: 4rem;
      height: 2rem;
    }

    // border-bottom: 0.01rem solid rgb(238, 238, 238);
  }

  .list_item02 {
    margin-left: 0.2rem;
      width: 100%;
    border-bottom: 0.01rem solid rgb(238, 238, 238);
    overflow: hidden;
    .cardName{
      font-size: 0.3rem;
    }

    .price {
      font-size: 0.5rem;
      padding: 0.15rem 0.21rem 0.15rem 0;
      color: rgb(255, 0, 0);
      font-weight: bold;
      font-size: 0.3rem;
    }
  .date_txt{
      font-size: 0.3rem; 
  }
  }

  .list_item03 {
    width: 100%;
    .numTxt {
      padding: 0.33rem 0rem 0.33rem 0rem;
      color: rgb(153, 153, 153);
      font-size: 0.26rem;
    }
    .btnBox {
      width: 1.58rem;
      height: 0.54rem;
      padding: 0.23rem 0.33rem 0.23rem 0rem;

      button {
        width: 100%;
        height: 100%;
        border-radius: 0.265rem;
        background-color: rgb(77, 205, 112);
        border: 0.01rem solid transparent;
        color: rgb(255, 255, 255);
        font-size: 0.3rem;
        text-align: center;
      }
    }
  }
}

.bodyContent {
  width: 100%;
  background-color: rgb(255, 255, 255);
  .title {
    width: 100%;
    // border-bottom: 0.01rem solid rgb(238, 238, 238);
    .txt {
      color: rgb(51, 51, 51);
      font-size: 0.3rem;
      padding: 0.31rem 0rem 0.32rem 0.32rem;
    }
  }
  .content {
    padding: 0 0.32rem;
  }

  .content_item {
    // border: 1px solid #efefef;
    //  margin-top: 0.31rem;
    width: 49%;
    .imgbox {
      margin: 0 auto;
      img {
        display: block;
        margin: 0 auto;
      }
    }
    .txt {
      color: rgb(51, 51, 51);
      text-align: center;
    }
    .num {
      text-align: center;
      padding-bottom: 0.2rem;
      color: rgb(153, 153, 153);

      font-size: 0.24rem;
      padding-top: 0.2rem;
    }
  }

  .content_item_left {
    border-right: 1px solid #efefef;
    border-top: 1px solid #efefef;
  }
  .content_item_right {
    border-top: 1px solid #efefef;
  }

}
</style>